import { lazy } from "react";
import { getBrand } from "@util/common";

const DynamicComponent = lazy(() => {
  switch (getBrand().toUpperCase()) {
    case "UQ":
      return import("../UQLayout");
    case "GU":
      return import("../GULayout");
    // case "PL":
    //   return import("../PLLayout");
    default:
      return import("../UQLayout");
  }
});

export default DynamicComponent;
